export default __webpack_public_path__ + "static/object-larger-dont-d3baae88cb3b661b654c7b0ffea93ecf.png";